import { render, staticRenderFns } from "./UnitOwnerList.vue?vue&type=template&id=6e2fa6e4&scoped=true"
import script from "./UnitOwnerList.vue?vue&type=script&lang=js"
export * from "./UnitOwnerList.vue?vue&type=script&lang=js"
import style0 from "./UnitOwnerList.vue?vue&type=style&index=0&id=6e2fa6e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2fa6e4",
  null
  
)

export default component.exports